<template>
  <div id="container">
    <h1 class="full_layout terms_title">Contact Card Hobby</h1>
    <div class="full_layout">
      <div class="contact_box like_box" v-if="this.list!=''">
        <el-image class="like_img" :src="list.TitImg" fit="contain"></el-image>
        <div class="like_detail">
          <p>{{list.Title}}</p>
          <div><span class="text_gray">Shipping:</span> {{list.USD_PostageMoney}}</div>
        </div>
      </div>
      <div class="contact_box">
        <div class="contact_title">Question you may ask</div>
        <el-collapse class="contact_collapse" @change="handleChange">
          <el-collapse-item class="contact_collapse_item" name="1">
            <template slot="title">
              Shipping(2)
            </template>
            <div class="QA">
              <p class="Q text_gray">Where do you ship from?</p>
              <p class="A">This item ships from oversea, California, United States</p>
            </div>
            <div class="QA">
              <p class="Q text_gray">Do you offer international shipping?</p>
              <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping fee.</p>
            </div>
          </el-collapse-item>
          <el-collapse-item class="contact_collapse_item" name="2">
            <template slot="title">
              {{$t('base.makeAnOffer')}}(1)
            </template>
            <div class="QA">
              <p class="Q text_gray">Do you offer international shipping?</p>
              <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping fee.</p>
            </div>
          </el-collapse-item>
          <el-collapse-item class="contact_collapse_item" name="3">
            <template slot="title">
              Pay for item(1)
            </template>
            <div class="QA">
              <p class="Q text_gray">Do you offer international shipping?</p>
              <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping fee.</p>
            </div>
          </el-collapse-item>
          <el-collapse-item class="contact_collapse_item" name="4">
            <template slot="title">
              Returns(1)
            </template>
            <div class="QA">
              <p class="Q text_gray">Do you offer international shipping?</p>
              <p class="A">Seller can send the item to Card Hobby in US. We will ship to you by international shipping with extra shipping fee.</p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="contact_box">
        <div class="contact_title">No, want to contact the seller ?<span class="text_blue">Instant contact</span></div>
        <div class="seller_answer">
          <div class="seller_answer_textarea">
            <div class="text_gray">Write someting to {{seller}}</div>
            <el-input type="textarea" resize="none" :rows="6" v-model="textarea"></el-input>
          </div>
          <p class="text_gray seller_answer_p">To keep everyone safe on Card Hobby,please don't send messages that include contact info.Repeated attempts could lead to an account suspension or other penalties.</p>
          <el-checkbox v-model="checked">Send a copy to my email address</el-checkbox>
          <div >
            <el-button type="primary">Send message</el-button>
            <el-button>Cancel</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import demo from "@/api/demo";
import bus from '@/api/bus';
export default {
  name: 'index',
  data () {
    return {
      list:"",
      seller:'',
      textarea: ''
    }
  },
  mounted(){
  },
  created(){
      this.list=this.$route.query.item;
      if(this.list!=""){
        this.list=JSON.parse(this.list)
      }
      this.seller=this.$route.query.seller;
      bus.$emit('headerTitle','Customer service');
  },
  methods: {
  } 
} 
</script>

<style scoped>
@import "../../../static/css/terms.css";
.contact_box{
  width: 520px;
  margin-bottom: 20px;
}
.contact_title{
  font-size: 18px;
}
.contact_title span{
  font-size: 16px;
  padding-left: 18px;
  margin-left: 16px;
  background:url(../../../static/images/icon/icon_chat.svg) no-repeat;
  cursor: pointer;
}
.contact_collapse{
  padding-left: 12px;
}
.like_box{
  display: flex;
}
.like_box .like_img{
  width: 88px;
  height: 88px;
  background-color: #e0e0e0;
  border-radius: 6px;
  margin-right: 12px;
}
.like_detail{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.seller_answer{
  padding-left: 12px;
  margin-top: 10px;
}
.seller_answer_textarea{
  border:1px solid #c8c8c8;
  border-radius: 5px;
  padding: 16px;
}
.seller_answer_p {margin: 10px 0;}
.el-button+.el-button{
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/terms/customer.vue